import { Toggle } from "@/components/Toggle";
import AppContext from "@/context/AppContext";
import { generatePlayerIframeCode } from "@/lib/helper";
import theme from "@/styles/theme";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import { grey } from "@mui/material/colors";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

export default function CopyPlayerIframeCode({ playlistType, playlistId }) {
  const { setSnackbar } = useContext(AppContext);
  const [showCode, setShowCode] = useState(false);
  const codeContainer = useRef(null);

  const code = useMemo(
    () => generatePlayerIframeCode(playlistType, playlistId),
    [playlistType, playlistId],
  );

  useEffect(() => {
    if (showCode) {
      codeContainer.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [showCode]);

  const handleToggleClick = () => {
    setShowCode(!showCode);
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(code);

    setSnackbar("Code wurde in die Zwischenablage kopiert.");
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="flex-end"
      sx={copyPlayerIframeCodeStyles}
      spacing={1}
    >
      <Grid item xs="auto">
        <Toggle
          name="copyIframe"
          label="Code anzeigen"
          value={showCode}
          onChange={handleToggleClick}
        />
      </Grid>
      <Grid item xs="auto" md={4}>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={handleCopyCode}
        >
          Code kopieren
        </Button>
      </Grid>
      {showCode && (
        <Fade in={showCode}>
          <Grid item xs={12} className="code-box-container">
            <Box className="code-box-content">
              <pre ref={codeContainer}>{code}</pre>
            </Box>
          </Grid>
        </Fade>
      )}
    </Grid>
  );
}

const copyPlayerIframeCodeStyles = {
  "& .code-box-container": {
    transform: "translateY(calc(100% - 0.0625rem))",
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    padding: "0 1.5rem 1.5rem 1.5rem",
    transition: "all 0.5s ease-in-out",
    backgroundColor: theme.palette.common.white,
    "& .code-box-content": {
      backgroundColor: grey[300],
      borderRadius: "0.25rem",
      "& pre": {
        overflow: "hidden",
        padding: "1rem",
        margin: "0 1rem 0 0",
        fontSize: "0.75rem",
        lineHeight: "1.1rem",
        color: grey[800],
      },
    },
  },
};
